const ReadyToAdvertiseChip = () => (
  <span className="vehicle-status-chip vehicle-status-chip--ready-to-advertise ch-fs--1 ch-fw--500 ch-display--flex ch-align-items--center">
    I&apos;ll be ready soon
  </span>
);

export default ReadyToAdvertiseChip;
